import { FormControl, Input, FormErrorMessage, Select } from "@chakra-ui/react";
import { useMemo } from "react";

import type { ContactFormStepProps, Duration } from "./ContactForm";

interface InputFieldProps extends ContactFormStepProps {
	label: string;
	error?: string;
	isRequired?: boolean;
	field: "name" | "datetime" | "duration" | "contact" | "queries";
}

export const InputField = (props: InputFieldProps) => {
	const {
		label,
		field,
		error,
		isFinalStep,
		isRequired = true,
		contactFormFields,
		setContactFormFields,
	} = props;

	const isError = isFinalStep && !contactFormFields[field];

	const fieldType = useMemo(() => {
		switch (field) {
			case "contact":
				return "tel" || "email";
			case "datetime":
				return "datetime-local";
			default:
				return undefined;
		}
	}, [field]);

	const fieldStyle = {
		size: "sm",
		rounded: "3",
		name: field,
		opacity: "69%",
		bg: "brand.light",
		variant: "outline",
		border: "solid 1.5px",
		borderColor: "brand.dark",
		_hover: { opacity: "100%" },
		value: contactFormFields[field],
		focusBorderColor: "brand.contrast",
		placeholder: label.toUpperCase(),
		_placeholder: { color: "brand.dark", opacity: "69%" },
	};

	return (
		<FormControl gap="1.5" w="100%" isInvalid={isError} isRequired={isRequired}>
			{field === "duration" ? (
				<Select
					{...fieldStyle}
					onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
						setContactFormFields((prevFields) => ({
							...prevFields,
							[field]: e.target.value as Duration,
						}));
					}}
				>
					<option value="1">1 hour</option>
					<option value="2">2 hours</option>
					<option value="3">3 hours</option>
					<option value="4">4 hours</option>
					<option value="6">6 hours</option>
				</Select>
			) : (
				<Input
					{...fieldStyle}
					type={fieldType}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setContactFormFields((prevFields) => ({
							...prevFields,
							[field]: e.target.value,
						}));
					}}
				/>
			)}
			{isError && <FormErrorMessage>{error}</FormErrorMessage>}
		</FormControl>
	);
};
